import requests from '../httpService';
import {
    LOGGEDIN_USER_INFO,
} from 'constants/homeConstants';

const getUserById = (id) => async (dispatch) => {
    await requests.get(`/contributors/${id}/get-user-by-id`)
                  .then((res) => {
                    if (res) {
                        dispatch({ type: LOGGEDIN_USER_INFO, payload: res})
                    }
                  })
}


export {
    getUserById
}